import React from 'react';
import clsx from 'clsx';
import styles from './ContractName.module.css';

export interface ContractNameProps {
  name: string;
  description?: string | null;
  className?: string;
}

const ContractName: React.FC<ContractNameProps> = ({ name, description, className }) => {
  return (
    <div className={clsx(className)}>
      <div className={styles.contractName}>{name}</div>
      {description && <div className={styles.contractDescription}>{description}</div>}
    </div>
  );
};

export default ContractName;
